import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { getPlanConfig } from '../../utils/membershipUtils';
import Pagination from '../../components/Pagination/Pagination';
import './ProfessionalPage.css';

const ProfessionalPage = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  // Filter states - ready for future implementation
  // const [selectedCategory, setSelectedCategory] = useState('');
  // const [selectedSubCategory, setSelectedSubCategory] = useState('');
  // const [selectedCountry, setSelectedCountry] = useState('');

  // Handle professional card click to navigate to profile
  const handleProfessionalClick = (professionalId) => {
    navigate(`/professional/${professionalId}`);
  };

  // Sample professional data - in production this would come from API
  const professionals = Array(12).fill(null).map((_, index) => ({
    id: index + 1,
    title: 'Architecture Engineer',
    name: 'Engr. Jerome Bell',
    country: 'United Kingdom',
    isGlobal: true,
    isVerified: true,
    rating: 4.5,
    category: 'Building Materials',
    expertise: 'Office Architecture, Home Architect',
    interestedLocations: 'USA, Canada, Sadia Arab, Dubai, Katar, Bangladesh, India',
    experience: '12 years',
    mainImage: 'https://api.builder.io/api/v1/image/assets/TEMP/58cc2d5bb5c7003c74e5576394c0058616e17b60?width=644',
    subImage1: 'https://api.builder.io/api/v1/image/assets/TEMP/1a2cb45832bfc68ef1cdfa70a1cbb4a00977bd43?width=320',
    subImage2: 'https://api.builder.io/api/v1/image/assets/TEMP/f1daad45a1f45d3d4a2196bb677710d48b6e710d?width=320',
    avatar: 'https://api.builder.io/api/v1/image/assets/TEMP/a2156ff56fa909d18d50d8cba4987a5ce91c6c35?width=160'
  }));

  const totalResults = 2342;

  const ProfessionalCard = ({ professional }) => (
    <div className="professional-card" onClick={() => handleProfessionalClick(professional.id)} style={{ cursor: 'pointer' }}>
      <div className="professional-card-content">
        {/* Image Gallery */}
        <div className="professional-gallery">
          <div className="professional-gallery-wrapper">
            <img 
              src={professional.mainImage}
              alt="Work sample"
              className="professional-main-image"
            />
            <div className="professional-sub-images">
              <img 
                src={professional.subImage1}
                alt="Work sample"
                className="professional-sub-image"
              />
              <img 
                src={professional.subImage2}
                alt="Work sample"
                className="professional-sub-image"
              />
            </div>
          </div>
        </div>

        {/* Professional Info */}
        <div className="professional-info">
          {/* Header Section */}
          <div className="professional-header">
            <div className="professional-avatar">
              <img 
                src={professional.avatar} 
                alt={professional.name}
                className="avatar-image"
              />
            </div>
            <div className="professional-header-content">
              <div className="professional-title-section">
                <div className="professional-title-wrapper">
                  <h3 className="professional-title">{professional.title}</h3>
                </div>
              </div>
              <div className="professional-name-location">
                <span className="professional-name">{professional.name}</span>
                <span className="professional-separator"> |  </span>
                <span className="professional-location">{professional.country}</span>
              </div>
              <div className="professional-badges">
                <div className="professional-badges-row">
                  {(() => {
                    const planConfig = getPlanConfig(professional.membershipPlan);
                    return (
                      <div className="professional-global-badge" style={{ borderColor: planConfig.color }}>
                        <img 
                          src={planConfig.icon} 
                          alt={planConfig.label} 
                          className="global-icon"
                        />
                        <span style={{ color: planConfig.color }}>{planConfig.label}</span>
                      </div>
                    );
                  })()}
                  {professional.isVerified && (
                    <div className="professional-verified-badge">
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22 11C22 11.9323 20.7329 12.6871 20.5034 13.5472C20.2653 14.4377 20.9782 15.7221 20.528 16.5015C20.0705 17.2923 18.597 17.314 17.9562 17.9562C17.314 18.5984 17.2923 20.0705 16.5014 20.528C15.7221 20.9782 14.4377 20.2653 13.5472 20.5034C12.6871 20.7329 11.9337 22 11 22C10.0663 22 9.31291 20.7329 8.45276 20.5034C7.56231 20.2653 6.27788 20.9782 5.49856 20.528C4.70769 20.0705 4.68605 18.597 4.04382 17.9562C3.4016 17.3154 1.92954 17.2923 1.47205 16.5015C1.02177 15.7221 1.73472 14.4377 1.49659 13.5472C1.26712 12.6871 0 11.9338 0 11C0 10.0663 1.26712 9.31291 1.49659 8.45276C1.73472 7.56231 1.02177 6.27788 1.47205 5.49856C1.92954 4.70769 3.40305 4.68605 4.04382 4.04382C4.68605 3.4016 4.70769 1.92954 5.49856 1.47205C6.27788 1.02177 7.56231 1.73472 8.45276 1.49659C9.31291 1.26712 10.0663 0 11 0C11.9337 0 12.6871 1.26712 13.5472 1.49659C14.4377 1.73472 15.7221 1.02177 16.5014 1.47205C17.2923 1.92954 17.314 3.40305 17.9562 4.04382C18.5984 4.68461 20.0705 4.70769 20.528 5.49856C20.9782 6.27788 20.2653 7.56231 20.5034 8.45276C20.7329 9.31291 22 10.0663 22 11Z" fill="#29ABE2"/>
                        <path d="M16.5876 7.60156C16.1229 7.13685 15.3696 7.13685 14.9049 7.60156L10.0312 12.4752L8.00786 10.4519C7.54315 9.98719 6.7898 9.98719 6.32509 10.4519C5.86039 10.9166 5.86039 11.6699 6.32509 12.1346L9.14798 14.9575C9.39188 15.2014 9.71372 15.3169 10.0327 15.3053C10.3516 15.3169 10.6734 15.2014 10.9173 14.9575L16.5891 9.28581C17.0538 8.82111 17.0538 8.06776 16.5891 7.60305L16.5876 7.60156Z" fill="white"/>
                      </svg>
                      <span className="verified-text">Verified</span>
                    </div>
                  )}
                </div>
                <div className="professional-rating">
                  <span className="rating-value">{professional.rating} </span>
                  <span className="rating-label">Reviews</span>
                </div>
              </div>
            </div>
          </div>

          {/* Details Section */}
          <div className="professional-details">
            <div className="professional-detail-row">
              <span className="detail-label">Category:</span>
              <span className="detail-value">{professional.category}</span>
            </div>
            <div className="professional-detail-row">
              <span className="detail-label">Expertise:</span>
              <span className="detail-value">{professional.expertise}</span>
            </div>
            <div className="professional-detail-row">
              <span className="detail-label">Interested location:</span>
              <span className="detail-value">{professional.interestedLocations}</span>
            </div>
            <div className="professional-detail-row">
              <span className="detail-label">Experience:</span>
              <span className="detail-value">{professional.experience}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="professional-page">
      <Header />
      
      <main className="professional-main">
        <div className="professional-container">
          {/* Page Header Section */}
          <div className="professional-page-header">
            <h1 className="professional-page-title">
              <span className="title-main">Professional | </span>
              <span className="title-count">{totalResults.toLocaleString()} result</span>
            </h1>
            <p className="professional-page-subtitle">
              GulfConstructor connects suppliers, professionals, and contractors with live project opportunities across the region.
            </p>
          </div>

          {/* Content Section */}
          <div className="professional-content-section">
            <div className="professional-content-wrapper">
              <div className="professional-listing-section">
                {/* Breadcrumb */}
                <div className="professional-breadcrumb">
                  <span className="breadcrumb-item">Home</span>
                  <svg className="breadcrumb-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 13L10 9L6 5" stroke="#505050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span className="breadcrumb-item active">Professional</span>
                </div>

                {/* Filters */}
                <div className="professional-filters">
                  <div className="filters-row">
                    <div className="filter-dropdown">
                      <span className="filter-label">Category</span>
                      <svg className="filter-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20.031 9.53104L12.531 17.031C12.4614 17.1008 12.3787 17.1561 12.2876 17.1938C12.1966 17.2316 12.099 17.251 12.0004 17.251C11.9019 17.251 11.8043 17.2316 11.7132 17.1938C11.6222 17.1561 11.5394 17.1008 11.4698 17.031L3.96979 9.53104C3.82906 9.39031 3.75 9.19944 3.75 9.00042C3.75 8.80139 3.82906 8.61052 3.96979 8.46979C4.11052 8.32906 4.30139 8.25 4.50042 8.25C4.69944 8.25 4.89031 8.32906 5.03104 8.46979L12.0004 15.4401L18.9698 8.46979C19.0395 8.40011 19.1222 8.34483 19.2132 8.30712C19.3043 8.26941 19.4019 8.25 19.5004 8.25C19.599 8.25 19.6965 8.26941 19.7876 8.30712C19.8786 8.34483 19.9614 8.40011 20.031 8.46979C20.1007 8.53947 20.156 8.6222 20.1937 8.71324C20.2314 8.80429 20.2508 8.90187 20.2508 9.00042C20.2508 9.09896 20.2314 9.19654 20.1937 9.28759C20.156 9.37863 20.1007 9.46136 20.031 9.53104Z" fill="#6D6D6D"/>
                      </svg>
                    </div>
                    <div className="filter-dropdown">
                      <span className="filter-label">Sub Category</span>
                      <svg className="filter-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20.031 9.53104L12.531 17.031C12.4614 17.1008 12.3787 17.1561 12.2876 17.1938C12.1966 17.2316 12.099 17.251 12.0004 17.251C11.9019 17.251 11.8043 17.2316 11.7132 17.1938C11.6222 17.1561 11.5394 17.1008 11.4698 17.031L3.96979 9.53104C3.82906 9.39031 3.75 9.19944 3.75 9.00042C3.75 8.80139 3.82906 8.61052 3.96979 8.46979C4.11052 8.32906 4.30139 8.25 4.50042 8.25C4.69944 8.25 4.89031 8.32906 5.03104 8.46979L12.0004 15.4401L18.9698 8.46979C19.0395 8.40011 19.1222 8.34483 19.2132 8.30712C19.3043 8.26941 19.4019 8.25 19.5004 8.25C19.599 8.25 19.6965 8.26941 19.7876 8.30712C19.8786 8.34483 19.9614 8.40011 20.031 8.46979C20.1007 8.53947 20.156 8.6222 20.1937 8.71324C20.2314 8.80429 20.2508 8.90187 20.2508 9.00042C20.2508 9.09896 20.2314 9.19654 20.1937 9.28759C20.156 9.37863 20.1007 9.46136 20.031 9.53104Z" fill="#6D6D6D"/>
                      </svg>
                    </div>
                    <div className="filter-dropdown">
                      <span className="filter-label">Country</span>
                      <svg className="filter-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20.031 9.53104L12.531 17.031C12.4614 17.1008 12.3787 17.1561 12.2876 17.1938C12.1966 17.2316 12.099 17.251 12.0004 17.251C11.9019 17.251 11.8043 17.2316 11.7132 17.1938C11.6222 17.1561 11.5394 17.1008 11.4698 17.031L3.96979 9.53104C3.82906 9.39031 3.75 9.19944 3.75 9.00042C3.75 8.80139 3.82906 8.61052 3.96979 8.46979C4.11052 8.32906 4.30139 8.25 4.50042 8.25C4.69944 8.25 4.89031 8.32906 5.03104 8.46979L12.0004 15.4401L18.9698 8.46979C19.0395 8.40011 19.1222 8.34483 19.2132 8.30712C19.3043 8.26941 19.4019 8.25 19.5004 8.25C19.599 8.25 19.6965 8.26941 19.7876 8.30712C19.8786 8.34483 19.9614 8.40011 20.031 8.46979C20.1007 8.53947 20.156 8.6222 20.1937 8.71324C20.2314 8.80429 20.2508 8.90187 20.2508 9.00042C20.2508 9.09896 20.2314 9.19654 20.1937 9.28759C20.156 9.37863 20.1007 9.46136 20.031 9.53104Z" fill="#6D6D6D"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Professionals List */}
            <div className="professionals-list">
              {professionals.map((professional) => (
                <ProfessionalCard key={professional.id} professional={professional} />
              ))}
            </div>

            {/* Pagination */}
            <Pagination currentPage={currentPage} totalPages={5} onPageChange={setCurrentPage} />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ProfessionalPage;
